import badges from "./badges";
import abFocusShotBg from "../../../../../../images/upsell/abFocusShotBg.jpg";
import abFocusShotMultiOverride from "../../../../../../images/upsell/abFocusShotMultiOverride.png";
import abFocusShotMultiMobileOverride from "../../../../../../images/upsell/abFocusShotMultiMobileOverride.png";
import shroomUpsellBg from "../../../../../../images/upsell/shroomUpsellBg.jpg";
import melatoninUpsellBg from "../../../../../../images/upsell/melatoninUpsellBg.jpg";
import alphaBrainUpsellBg from "../../../../../../images/upsell/alphabrain.jpg";
import alphaBrain30TrialUpsellBg from "../../../../../../images/upsell/alphaBrain30TrialUpsellBg.jpg";
import alphaBrainInstantUpsellBg from "../../../../../../images/upsell/abiUpsellBg.jpg";
import abiInstantStick from "../../../../../../images/upsell/abInstant.jpg";
import stiUpsellBg from "../../../../../../images/upsell/stiUpsellBg.jpg";
import tghUpsellBg from "../../../../../../images/upsell/tghUpsell.jpg";
import newMoodUpsellBg from "../../../../../../images/upsell/newMoodUpsellBg.jpg";
import o6KettlebellUpsellBg from "../../../../../../images/upsell/o6Kettlebell.jpg";
import o6SteelClubUpsellBg from "../../../../../../images/upsell/o6SteelClub.jpg";
import o6SteelMaceUpsellBg from "../../../../../../images/upsell/o6SteelMace.jpg";
import onnitAlphaBrainUpsellBg from "../../../../../../images/upsell/onnitAlphaBrainUpsellBg.jpg";
import onnitNewMoodUpsellBg from "../../../../../../images/upsell/onnitNewMoodUpsellBg.jpg";
import onnitJointOilUpsellBg from "../../../../../../images/upsell/onnitJointOilUpsellBg.jpg";
import onnitTotalHumanTrialUpsellBg from "../../../../../../images/upsell/onnitTotalHumanTrialUpsellBg.jpg";
import o6ProgramBg from "../../../../../../images/upsell/o6ProgramBgRev.jpg";
import o6AuthorityOverride from "../../../../../../images/upsell/o6AuthorityOverride.png";
import o6AuthorityOverrideMobile from "../../../../../../images/upsell/o6AuthorityOverrideMobile.png";
import nmiBg from "../../../../../../images/upsell/nmiBg.jpg";
import nmiOverride from "../../../../../../images/upsell/nmiOverride.png";
import nmiOverrideMobile from "../../../../../../images/upsell/nmiOverrideMobile.png";
import onnitIn30Bg from "../../../../../../images/upsell/onnitIn30Bg.jpg";
import onnitIn30Override from "../../../../../../images/upsell/onnitIn30Override.png";
import onnitIn30OverrideMobile from "../../../../../../images/upsell/onnitIn30OverrideMobile.png";
import thBg from "../../../../../../images/upsell/thBg.jpg";
import tghBg from "../../../../../../images/upsell/tghBg.jpg";
import vtiBg from "../../../../../../images/upsell/vtiBg.jpg";
import vtiOverride from "../../../../../../images/upsell/vtiOverride.png";
import vtiOverrideMobile from "../../../../../../images/upsell/vtiOverrideMobile.png";
import stgBg from "../../../../../../images/upsell/stgBg.jpg";
import abiOverride from "../../../../../../images/upsell/abiOverride.png";
import abiOverrideMobile from "../../../../../../images/upsell/abiOverrideMobile.png";
import abPreOverride from '../../../../../../images/upsell/abPreOverride.png';
import abPreOverrideMobile from '../../../../../../images/upsell/abPreOverrideMobile.png';
import wheyOverride from '../../../../../../images/upsell/wheyOverride.png';
import wheyOverrideMobile from '../../../../../../images/upsell/wheyOverrideMobile.png';

interface Badge {
    name: string;
    src: string;
    style: {
        [key: string]: string | number;
    };
}

export type ProductNameTransform = (name: string, pid?: number) => string;

export interface UpsellTheme {
    layoutReversed: boolean;
    bgImage: string;
    colors: {
        primary: string;
        primaryText: string;
        accent: string;
        rating: string;
    };
    containsHemp?: boolean;
    is18AndUp?: boolean;
    badges: Badge[];
    // This is used in the MultiProduct template
    productNameTransform?: ProductNameTransform;
}

export interface MultiProductUpsellTheme extends UpsellTheme {
    authorityImageOverride: string;
    authorityImageOverrideMobile: string;
}

interface UpsellThemes {
    [key: string]: UpsellTheme | MultiProductUpsellTheme;
}

export const isMultiProductUpsellTheme = (theme: UpsellTheme): theme is MultiProductUpsellTheme => "authorityImageOverride" in theme;

const themes: UpsellThemes = {
    abi_multi: {
        layoutReversed: false,
        bgImage: onnitAlphaBrainUpsellBg,
        authorityImageOverride: abiOverride,
        authorityImageOverrideMobile: abiOverrideMobile,
        colors: {
            primary: "#e0bb29",
            primaryText: "#000000",
            accent: "#ffffff",
            rating: "#e0bb29",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/Alpha BRAIN® Instant - /giu, ""),
    },
    abi_variety: {
        layoutReversed: false,
        bgImage: onnitAlphaBrainUpsellBg,
        colors: {
            primary: "#e0bb29",
            primaryText: "#000000",
            accent: "#ffffff",
            rating: "#e0bb29",
        },
        badges: [],
    },
    nmi_variety: {
        layoutReversed: false,
        bgImage: onnitNewMoodUpsellBg,
        colors: {
            primary: "#e0bb29",
            primaryText: "#000000",
            accent: "#ffffff",
            rating: "#e0bb29",
        },
        badges: [],
    },
    mct_oil: {
        layoutReversed: false,
        bgImage: onnitJointOilUpsellBg,
        colors: {
            primary: "#e0bb29",
            primaryText: "#000000",
            accent: "#ffffff",
            rating: "#e0bb29",
        },
        badges: [],
    },
    onnit_ab_focus_shot_multi: {
        layoutReversed: false,
        bgImage: abFocusShotBg,
        colors: {
            primary: "#48dfc1",
            primaryText: "#000000",
            accent: "#48dfc1",
            rating: "#D0B6D5",
        },
        authorityImageOverride: abFocusShotMultiOverride,
        authorityImageOverrideMobile: abFocusShotMultiMobileOverride,
        badges: [badges.gluten, badges.dairy],
    },
    onnit_stg: {
        layoutReversed: false,
        bgImage: stgBg,
        colors: {
            primary: "#ebdc31",
            primaryText: "#000000",
            accent: "#a0fce0",
            rating: "#D0B6D5",
        },
        badges: [badges.gluten, badges.vegan],
    },
    "onnit_th-30": {
        layoutReversed: false,
        bgImage: thBg,
        colors: {
            primary: "#cfb272",
            primaryText: "#000000",
            accent: "#56c1b6",
            rating: "#D0B6D5",
        },
        badges: [],
    },
    "onnit_tgh-30": {
        layoutReversed: false,
        bgImage: tghBg,
        colors: {
            primary: "#249f8f",
            primaryText: "#000000",
            accent: "#ffffff",
            rating: "#D0B6D5",
        },
        badges: [badges.dairy, badges.gluten, badges.soy],
    },
    "ab_preworkout_multi": {
        layoutReversed: false,
        bgImage: thBg,
        authorityImageOverride: abPreOverride,
        authorityImageOverrideMobile: abPreOverrideMobile,
        colors: {
            primary: "#e19226",
            primaryText: "#000000",
            accent: "#e19226",
            rating: "#D0B6D5",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/Alpha BRAIN® Pre-Workout - /giu, ""),
    },
    "whey_protein_multi": {
        layoutReversed: false,
        bgImage: thBg,
        authorityImageOverride: wheyOverride,
        authorityImageOverrideMobile: wheyOverrideMobile,
        colors: {
            primary: "#56c1b6",
            primaryText: "#000000",
            accent: "#56c1b6",
            rating: "#D0B6D5",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/Grass Fed Whey Isolate Protein - /giu, ""),
    },
    virutech_instant_multi: {
        layoutReversed: false,
        bgImage: vtiBg,
        authorityImageOverride: vtiOverride,
        authorityImageOverrideMobile: vtiOverrideMobile,
        colors: {
            primary: "#ffcc5e",
            primaryText: "#000000",
            accent: "#ffcc5e",
            rating: "#D0B6D5",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/ViruTech®? Immune Instant - /giu, ""),
    },
    virutech_instant_orange: {
        layoutReversed: false,
        bgImage: vtiBg,
        colors: {
            primary: "#ffcc5e",
            primaryText: "#000000",
            accent: "#ffcc5e",
            rating: "#D0B6D5",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/ViruTech®? Immune Instant - /giu, ""),
    },
    onnitIn30_multi: {
        layoutReversed: false,
        bgImage: onnitIn30Bg,
        authorityImageOverride: onnitIn30Override,
        authorityImageOverrideMobile: onnitIn30OverrideMobile,
        colors: {
            primary: "#f2334f",
            primaryText: "#000000",
            accent: "#ffffff",
            rating: "#D0B6D5",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/Onnit In 30 - /giu, ""),
    },
    nmi_multi: {
        layoutReversed: false,
        bgImage: nmiBg,
        authorityImageOverride: nmiOverride,
        authorityImageOverrideMobile: nmiOverrideMobile,
        colors: {
            primary: "#FF675D",
            primaryText: "#000000",
            accent: "#D0B6D5",
            rating: "#D0B6D5",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/New MOOD®? Instant - /giu, ""),
    },
    nmi_elderberry: {
        layoutReversed: false,
        bgImage: nmiBg,
        colors: {
            primary: "#FF675D",
            primaryText: "#000000",
            accent: "#D0B6D5",
            rating: "#D0B6D5",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/New MOOD®? Instant - /giu, ""),
    },
    multi_o6_program: {
        layoutReversed: false,
        bgImage: o6ProgramBg,
        authorityImageOverride: o6AuthorityOverride,
        authorityImageOverrideMobile: o6AuthorityOverrideMobile,
        colors: {
            primary: "#5fdfe8",
            primaryText: "#000000",
            accent: "#f2d75a",
            rating: "#f2d75a",
        },
        badges: [],
    },
    "onnit_total-human-7": {
        layoutReversed: false,
        bgImage: onnitTotalHumanTrialUpsellBg,
        colors: {
            primary: "#58d0c0",
            primaryText: "#000000",
            accent: "#C5A981",
            rating: "#58d0c0",
        },
        badges: [badges.gluten],
    },
    "onnit_nm-30": {
        layoutReversed: false,
        bgImage: onnitNewMoodUpsellBg,
        colors: {
            primary: "#BCC9DC",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#BCC9DC",
        },
        badges: [badges.gluten, badges.dairy, badges.caffeine],
    },
    "onnit_ab-30": {
        layoutReversed: false,
        bgImage: onnitAlphaBrainUpsellBg,
        colors: {
            primary: "#658e48",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#658e48",
        },
        badges: [badges.gluten, badges.caffeine],
    },
    ab_black_label: {
        layoutReversed: false,
        bgImage: onnitAlphaBrainUpsellBg,
        colors: {
            primary: "#658e48",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#658e48",
        },
        badges: [],
    },
    "onnit_ab-30-trial": {
        layoutReversed: false,
        bgImage: alphaBrain30TrialUpsellBg,
        colors: {
            primary: "#ef6344",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#ef6344",
        },
        badges: [badges.gluten, badges.dairy, badges.caffeine],
    },
    "onnit_joint-oil": {
        layoutReversed: false,
        bgImage: onnitJointOilUpsellBg,
        colors: {
            primary: "#ed882c",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#658e48",
        },
        badges: [badges.gluten, badges.informedSport],
    },
    "onnit-6_steel-mace": {
        layoutReversed: false,
        bgImage: o6SteelMaceUpsellBg,
        colors: {
            primary: "#dbbb6d",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#BCC9DC",
        },
        badges: [],
    },
    "onnit-6_steel-club": {
        layoutReversed: false,
        bgImage: o6SteelClubUpsellBg,
        colors: {
            primary: "#fd5a37",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#BCC9DC",
        },
        badges: [],
    },
    "onnit-6_kettlebell": {
        layoutReversed: false,
        bgImage: o6KettlebellUpsellBg,
        colors: {
            primary: "#20A090",
            primaryText: "#ffffff",
            accent: "#F7A800",
            rating: "#BCC9DC",
        },
        badges: [],
    },
    "jumbleberry_nm-60": {
        layoutReversed: false,
        bgImage: newMoodUpsellBg,
        colors: {
            primary: "#BCC9DC",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#BCC9DC",
        },
        badges: [badges.dairy, badges.gluten, badges.caffeine],
    },
    "jumbleberry_nm-30": {
        layoutReversed: false,
        bgImage: newMoodUpsellBg,
        colors: {
            primary: "#BCC9DC",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#BCC9DC",
        },
        badges: [badges.dairy, badges.gluten, badges.caffeine],
    },
    jumbleberry_tgh: {
        layoutReversed: false,
        bgImage: tghUpsellBg,
        colors: {
            primary: "#20A090",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#658e48",
        },
        badges: [badges.dairy, badges.gluten, badges.vegan],
    },
    "jumbleberry_ab-30": {
        layoutReversed: false,
        bgImage: alphaBrainUpsellBg,
        colors: {
            primary: "#658e48",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#658e48",
        },
        badges: [badges.gluten, badges.caffeine],
    },
    "jumbleberry_ab-90": {
        layoutReversed: false,
        bgImage: alphaBrainUpsellBg,
        colors: {
            primary: "#658e48",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#658e48",
        },
        badges: [badges.gluten, badges.caffeine],
    },
    jumbleberry_abi: {
        layoutReversed: false,
        bgImage: alphaBrainInstantUpsellBg,
        colors: {
            primary: "#658e48",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#658e48",
        },
        badges: [badges.gluten, badges.caffeine],
    },
    "jumbleberry_abi-stick": {
        layoutReversed: false,
        bgImage: abiInstantStick,
        colors: {
            primary: "#658e48",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#658e48",
        },
        badges: [badges.gluten, badges.caffeine],
    },
    "jumbleberry_sti-90": {
        layoutReversed: false,
        bgImage: stiUpsellBg,
        colors: {
            primary: "#7cb742",
            primaryText: "#000000",
            accent: "#F7A800",
            rating: "#7cb742",
        },
        badges: [badges.gluten, badges.soy, badges.vegan],
    },
    "jumbleberry_shroom-tech-sport": {
        layoutReversed: true,
        bgImage: shroomUpsellBg,
        colors: {
            primary: "#02b35e",
            primaryText: "#000000",
            accent: "#f7a800",
            rating: "#02b35e",
        },
        badges: [],
    },
    jumbleberry_melatonin: {
        layoutReversed: false,
        bgImage: melatoninUpsellBg,
        colors: {
            primary: "#7262bd",
            primaryText: "#ffffff",
            accent: "#f7a800",
            rating: "#ffffff",
        },
        badges: [],
        productNameTransform: (name) => name.replace(/Melatonin Spray - /giu, ""),
    },
};

export default themes;
